/* ============================================================
   Hauptmenü (Hamburger): auf/zu, Klick außerhalb & ESC schließen
   ============================================================ */
(function(){
  var btn = document.getElementById('menuBtn');
  var menue = document.getElementById('hauptmenue');
  if(!btn || !menue) return;

  function schliessen(){
    menue.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
  }
  function oeffnen(){
    menue.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  }
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    menue.hidden ? oeffnen() : schliessen();
  });
  document.addEventListener('click', function(e){
    if(!menue.hidden && !menue.contains(e.target)) schliessen();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') schliessen();
  });
  menue.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', schliessen);
  });
})();
